import React from 'react';
import { useTable } from '../../context/TableContext.js';
import StateIO from '../io/StateIO.js';
export default function StatusBar() {
  const { state } = useTable();

  const getSelectedCellInfo = () => {
    if (!state.selectedCell) return 'None';
    
    const row = state.selectedCell.row;
    const col = state.selectedCell.col;
    const columnLetter = String.fromCharCode(65 + col); // A, B, C, etc.
    return `Cell ${columnLetter}${row + 1}`;
  };

  return (
    <footer className="bg-white border-t border-gray-200 px-6 py-3">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center space-x-6 text-sm text-gray-600">
          <span>
            Selected: <span className="font-medium" data-testid="text-selected-cell">
              {getSelectedCellInfo()}
            </span>
          </span>
        </div>
        {/* <div className="flex items-center space-x-4 text-sm text-gray-600">
          <span>Press Ctrl+Z/Ctrl+Y for undo/redo</span>
          <span>Click cell to select, double-click to edit</span>
        </div> */}
        <StateIO/>
      </div>
    </footer>
  );
}
